import type { MaybeComputedElementRef } from "@vueuse/core";
import type { MaybeRefOrGetter } from "vue";
import { unrefElement, whenever } from "@vueuse/core";
import { toValue } from "vue";

export interface UseElementAutoOptions {
  enabled?: MaybeRefOrGetter<boolean>;
}

export function useElementAutoFocus(element: MaybeComputedElementRef<HTMLElement>, options: UseElementAutoOptions = {}) {
  whenever(() => unrefElement(element), el => {
    const enabled = toValue(options.enabled);
    if (enabled) {
      // nextTick wasn't enough in some cases, e.g. when reka-ui moves focus to another element right after mount
      // use setTimeout to perform focus/select in next event loop
      setTimeout(() => {
        el.focus();
      }, 0);
    }
  }, { immediate: true });
}

export function useElementAutoSelect(element: MaybeComputedElementRef<HTMLInputElement>, options: UseElementAutoOptions = {}) {
  whenever(() => unrefElement(element), el => {
    const enabled = toValue(options.enabled);
    if (enabled) {
      // nextTick wasn't enough in some cases, e.g. when reka-ui moves focus to another element right after mount
      // use setTimeout to perform focus/select in next event loop
      setTimeout(() => {
        if (el) {
          el.select();
        }
      }, 0);
    }
  }, { immediate: true });
}
